module.exports = __webpack_public_path__ + "img/tissue-img.eba607bd.png";